import { PayloadAction } from '@reduxjs/toolkit';

import { ConditionAddress, DesignState } from 'editor/src/store/design/types';

const updateConditionShowOnAllSpreadsReducer = (
  state: DesignState,
  action: PayloadAction<{ address: ConditionAddress; showOnAllSpreads: boolean }>,
) => {
  const { address, showOnAllSpreads } = action.payload;
  const { spreadIndex, conditionId } = address;
  const condition = state.designData?.spreads[spreadIndex]?.conditionGroup?.conditions[conditionId];
  if (!condition) {
    return;
  }

  condition.showOnAllSpreads = showOnAllSpreads || undefined;
};

export default updateConditionShowOnAllSpreadsReducer;
